import styled from "styled-components";
import {TextType} from "@dropDesk/presentation/pages/subscription/ui/select_plan/total_plan/styled";
import {hexToRGBA} from "@dropDesk/utils/helpers/colors";
import {ButtonPayType} from "@dropDesk/presentation/pages/subscription/ui/detail_subscription/invoices_history/styled";

export const ContainerAction = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const Text = styled.span<TextType>`
  font-size: ${(props) => props.size}px;
  color: ${(props) => props.color};
`;

export const TextLink = styled.a<TextType>`
  font-size: ${(props) => props.size}px;
  color: ${props => props.color};

  &:hover {
    text-decoration: underline;
  }
`;

export const ContentButtonTable = styled.span<ButtonPayType>`
  font-size: ${(props) => props.size}px;
  color: ${(props) => props.color};
  padding: 2px 16px;
  border: 1px solid ${props => props.color};
  border-radius: 5px;
  background: ${(props) => props.background};
  cursor: pointer;

  &:hover {
    border: none;
    box-shadow: 0 0 0 2px ${props => hexToRGBA(props.accent, .58)};
    outline: none;
    transition: box-shadow .3s ease-out .1s, border .3s ease-out, border-radius .3s ease-out, background-color .2s ease-out, color .2s ease-out, transform .2s ease-out;
  }
`;
